/**
 * @generated SignedSource<<bcab0268ee613b77295950617e0e229c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AppBuildState = "DISABLED" | "PENDING_BRAND_SETUP" | "PENDING_KINN_SETUP" | "PRE_PRODUCTION" | "PRODUCTION" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InternBrandScrapeAndSaveButton_brand$data = {
  readonly appConfig: {
    readonly appLaunchDate: any | null;
    readonly appState: AppBuildState;
    readonly id: string;
  };
  readonly id: string;
  readonly " $fragmentType": "InternBrandScrapeAndSaveButton_brand";
};
export type InternBrandScrapeAndSaveButton_brand$key = {
  readonly " $data"?: InternBrandScrapeAndSaveButton_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternBrandScrapeAndSaveButton_brand">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternBrandScrapeAndSaveButton_brand",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appState",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appLaunchDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "33a02e3294d41696313508417c569d86";

export default node;
